import React from 'react'

export default function AddInvoiceTemplate() {
  return (
    <div>
      <h1>Add Invoice Template</h1>
    </div>
  )
}
